import { Button, DialogActions, DialogContent, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, TextField } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import React, { useState } from "react";
import { orderStatusFormatted } from "src/constant";
import useAppGlobal from "src/context/useAppGlobal";
import useOrderTrackingStatus from "src/hooks/orders/useOrderTrackingStatus";

export default function OrderUnsuccessfulDialog({ item, mutate }) {
  const [type, setType] = useState();
  const [returnReason, setReturnReason] = useState(undefined);
  const { closeDialog } = useAppGlobal();
  const { trigger: changeStatus } = useOrderTrackingStatus();

  const handleConfirm = async () => {
    const res = await changeStatus({
      pathIncluded: {
        orderId: item?._id,
      },
      body: {
        trackingStatus: type,
        warehouse: item?.warehouse,
        returnReason: returnReason ?? undefined,
      },
    });
    if (res?.success) {
      closeDialog();
      mutate();
      return enqueueSnackbar("Thành công", { variant: "success" });
    } else {
      return enqueueSnackbar(res?.error?.message ?? "Lỗi khi xác nhận giao hàng không thành công", { variant: "error" });
    }
  };
  return (
    <>
      <DialogContent>
        <Grid container>
          <Grid
            xs={12}
            item
          >
            <FormControl>
              <FormLabel id="demo-radio-buttons-group-label">Chọn loại giao hàng</FormLabel>
              <RadioGroup
                onChange={(e) => setType(e.target.value)}
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
              >
                <FormControlLabel
                  value={orderStatusFormatted.DeliveredFailed}
                  control={<Radio />}
                  label="Khách không nhận hàng"
                />
                <FormControlLabel
                  value={orderStatusFormatted.Lost}
                  control={<Radio />}
                  label="Thất lạc"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid
            item
            xs={12}
            mt="12px"
          >
            <TextField
              disabled={type === orderStatusFormatted.Lost}
              placeholder="Vd: Khách không nhấc máy..."
              onChange={(e) => setReturnReason(e.target.value)}
              fullWidth
              rows={6}
              multiline
              label="Nhập lý do giao không thành công"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ p: "0 24px 24px" }}>
        <Button
          onClick={handleConfirm}
          sx={{ flex: "60%" }}
          variant="contained"
        >
          Xác nhận
        </Button>
      </DialogActions>
    </>
  );
}
